module.exports = __webpack_public_path__ + "img/img14.b9ef6e03.svg";